import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import { observer } from 'mobx-react'

import ExpertPage from './ExpertPage'
import ExpertSearchPage from './ExpertSearchPage'

// import ExpertSearchStore from './expertSearch.store'

class ExpertRoutes extends Component {
  /* constructor (props) {
    super(props)

    extendObservable(this, {
      expertSearchStore: new ExpertSearchStore()
    })
  } */

  render () {
    return (
      <Switch>
        <Route path='/expert/:id' component={ExpertPage} />
        <Route path='/expert-search' component={ExpertSearchPage} />
      </Switch>
    )
  }
}

export default observer(ExpertRoutes)
